import moment from 'moment';

export default function relativeTime(value) {
  if (value) {
    moment.locale('es');

    return moment(String(value)).fromNow();
  }

  return value;
}
